<app-sidebar-logo />
<app-sidebar-menu />

<app-sidebar-settings />
@if (electron) {
<div class="electron-sync-paused">
  <div class="electron-sync__item">
    <span class="electron-sync__item__svg" [class]="{ 'active': isActive, 'inactive': !isActive }">
      <svg-icon class="svgImage"
        [applyClass]="true"
        src="{{ isActive ? '/assets/img/icons/sync.svg' : '/assets/img/icons/sync_error.svg' }}"
       />
    </span>
    <app-input-checkbox-switch labelName="pidrive-sync-paused"
      [(ngModel)]="isActive"
      [isSwitchBackgroundOffLightRed]="!isActive"
      [isSwitchBackgroundOnMonteCarlo]="isActive"
      tooltip="{{
        isActive ? translate.instant('electron.sidebar.sync-on') : translate.instant('electron.sidebar.sync-off')
      }}"
      boundariesElement="viewport"
      container="body"
     />
  </div>
</div>
}
